import PropTypes from 'prop-types';
import { Column } from 'react-base-table';
import ActionsCell from './ActionsCell';

const ActionsColumn = () => {};

ActionsColumn.defaultProps = {
  cellRenderer: ActionsCell,
  onEditCell: null,
};

ActionsColumn.propTypes = {
  ...Column.propTypes,
  t: PropTypes.func.isRequired,
  onEditCell: PropTypes.func,
  customActionsCell: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
      tooltip: PropTypes.string.isRequired,
      callback: PropTypes.func.isRequired,
    }).isRequired
  ),
  customActionsToolbar: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
      tooltip: PropTypes.string.isRequired,
      callback: PropTypes.func.isRequired,
    }).isRequired
  ),
};

export default ActionsColumn;
